import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiHome, FiTrendingUp, FiBarChart2, FiLayers, FiActivity, FiSettings, FiLogOut } from 'react-icons/fi';
import { SiConvertio } from 'react-icons/si';
import { useAuthStore } from '../store/authStore';

const menuItems = [
  { path: '/dashboard', icon: FiHome, label: 'Overview' },
  { path: '/dashboard/trading', icon: FiTrendingUp, label: 'Trading Control' },
  { path: '/dashboard/market', icon: FiBarChart2, label: 'Market Data' },
  { path: '/dashboard/strategies', icon: FiLayers, label: 'Strategies' },
  { path: '/dashboard/botstate', icon: FiActivity, label: 'Bot State' },
  { path: '/dashboard/exchanges', icon: SiConvertio, label: 'Exchanges' },
  { path: '/dashboard/settings', icon: FiSettings, label: 'Settings' },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="w-64 fixed h-full border-r border-border bg-surface hidden md:flex flex-col">
      <div className="p-6 border-b border-border">
        <h1 className="text-2xl font-black font-heading tracking-tight text-primary">MROD SUPERBOT</h1>
        <p className="text-xs text-text-muted mt-1">Control Center</p>
      </div>
      <nav className="flex-1 p-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-sm font-medium uppercase text-xs tracking-wider transition-all ${isActive ? 'bg-primary/10 text-primary border border-primary/20' : 'text-text-muted hover:bg-white/5 hover:text-text-main'}`}
            >
              <Icon size={18} />
              {item.label}
            </Link>
          );
        })}
      </nav>
      <div className="p-4 border-t border-border">
        <div className="mb-4">
          <p className="text-xs text-text-muted">Logged in as</p>
          <p className="text-sm font-medium text-text-main truncate">{user?.email}</p>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 w-full px-4 py-2 text-xs uppercase tracking-wider font-bold bg-destructive/10 text-destructive border border-destructive/50 hover:bg-destructive/20 rounded-sm"
        >
          <FiLogOut size={16} />
          Logout
        </button>
      </div>
    </div>
  );
}
